import React from 'react';

import { MenuItem, Select } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import PromoDisplayConditionType from './PromoDisplayConditionType';

type Props = {
  conditionTypes: definitions['RuleJson']['conditions'][0]['conditionType'][];
  value: string;
  onChange: (value: string) => void;
  size: 'small' | 'medium';
};

const PromoDisplayConditionTypeSelect = ({ conditionTypes, value, onChange, size, ...props }: Props) => {
  return (
    <Select
      size={size}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      renderValue={(selectedValue) => <PromoDisplayConditionType conditionType={selectedValue as any} />}
      sx={{ minWidth: 120, fontSize: '0.875rem' }}
      {...props}
    >
      {conditionTypes?.map((conditionType) => (
        <MenuItem key={conditionType} value={conditionType}>
          <PromoDisplayConditionType conditionType={conditionType} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default PromoDisplayConditionTypeSelect;
